// Single source of truth for the Creator Plan price. Update here only.
export const PRICE_AMOUNT = 19.99;
export const PRICE = `$${PRICE_AMOUNT}`;
export const PRICE_PER_MONTH = `${PRICE}/mo`;
export const PLAN_LOOKUP_KEY = "creator_monthly";
